import { Component } from "@angular/core";
import { NavController, AlertController } from "ionic-angular";

import { GlobalProvider } from "../../providers/global/global";
import { ConectorProvider } from "../../providers/conector/conector";

import { CuadrantePropioPage } from "../../pages/cuadrante-propio/cuadrante-propio";

import * as moment from "moment";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  data: any = {};

  usuario: any;

  items: any;

  plataforma: any;

  constructor(
    public navCtrl: NavController,
    public global: GlobalProvider,
    public conector: ConectorProvider,
    public alertController: AlertController
  ) {
    this.usuario = this.global.DATAUSER;

    this.data = {
      background: "assets/images/background/39.jpg",
      subtitle: "Intranet de empleados",
      title: this.usuario.usuario,

      logo: "assets/imgs/logoAloew300.png"
    };

    let fechaCuadrante = moment(new Date()).format("DD-MM-YYYY");

    this.conector.getcuadrantepropio(fechaCuadrante).subscribe(data => {
      this.items = data["turnos"];
      console.log("turnos", this.items);
    });
  }

  ionViewWillEnter() {
    console.log("ionViewWillEnter homepage");
    window["isUpdateAvailable"].then(isAvailable => {
      if (isAvailable) {
        const alert = this.alertController.create({
          title: "Hay una nueva versión de la app",
          message:
            "Es neceario cerrarla completamente y volver a entrar para su instalación",
          buttons: [
            {
              text: "Aceptar",
              handler: () => {}
            }
          ]
        });

        alert.present();
      }
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad homepage");
  }
  iraCuadrante(item) {
    console.log("ir a cuadrante ", item);
    this.navCtrl.push(CuadrantePropioPage, { fecha: item.fecha });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts